import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';
import type { Database } from '@/types/database.generated';

/**
 * Browser Supabase client. Uses the publishable/anon key — RLS enforces every
 * read/write. Never instantiate the service-role client in the web app.
 * Sessions persist in localStorage and are auto-refreshed.
 */
export const supabase: SupabaseClient<Database> = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storageKey: 'clinio-v2-auth',
    },
    global: {
      headers: {
        'x-application-name': 'clinio-web',
      },
    },
  },
);

export type ClinioSupabaseClient = SupabaseClient<Database>;
